
import Store from '../store/Store'

export default class {

    static setQueryParameter(context, parameter, value) {
        //sets a query param without affecting history, or other parameters...
        //context should be set to 'this'
        let newQuery = Object.assign({}, context.$route.query)
        newQuery[parameter] = value
        context.$router.replace({ query:newQuery })
    } 
    
}


// WEBPACK FOOTER //
// ./src/helpers/RouterHelpers.js